<script setup>
import { defineProps } from "vue";
import SearchCircleIcon from "./svg-icons/SearchCircleIcon.vue";

const props = defineProps({
  errorMsg: {
    type: String,
    required: false,
    default: () => {
      return "Oh no, we couldn't find any results that fit your criteria.";
    },
  },
  secondaryMsg: {
    type: String,
    required: false,
    default: "",
  },
  color: {
    type: String,
    required: false,
    default: () => {
      return "#007F80";
    },
  },
  marginTop: {
    type: String,
    default: "mt-24",
  },
});
</script>

<template>
  <div class="w-full font-montserrat" :class="marginTop">
    <!-- Search Icons -->
    <div class="flex justify-center items-center">
      <SearchCircleIcon 
        :color="color" 
        :secondary-color="secondaryColor" 
      />
    </div>
    <!-- Search not found text -->
    <div class="flex justify-center items-center mt-14">
      <div class="w-3/6 text-center text-2xl">
        <p
          class="text-[36px] leading-[43px] font-bold not-italic text-[#1E264C]"
        >
          {{ props.errorMsg }}
        </p>
        <p v-if="props.secondaryMsg" class="mt-9 text-[#1E264C]">
          {{ props.secondaryMsg }}
        </p>
        <p v-else class="mt-9 text-[#1E264C]">
          Try removing some filters or explore our
          <router-link
            id="trending-programs-link"
            :to="{
              name: 'home',
            }"
            :class="`${secondaryColor}` ? `${secondaryColorClass}` : `text-teal-900`"
            >trending programs</router-link
          >
          to get inspired!
        </p>
      </div>
    </div>
  </div>
</template>
